module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gAuy7"))).then(() => parcelRequire('1iHdE'));